import * as HELPER from "../../../src/config/helper";
import { useLanguage } from "../../../src/context/LanguageContext";
import {RemittanceDate} from '../../component/DatePicker';
import { useState,useEffect } from "react";
import moment from 'moment';
import FullPageLoader from '@src/common/FullPageLoader';
import ConfirmPopup from '../../../src/common/ConfirmPopUp';
import { useParams } from "react-router-dom";
import {REMITTANCE_TYPE,LEAD_ASSIGN_TO,ADMIN_OPS_STATUS,ADMIN_MAKER_STATUS,ADMIN_CHECKER_STATUS,ADMIN_CHECKER_COMPLETE_STATUS} from '../../../src/config/constant';
import { saveRemittanceDetails } from '../../../src/store/slices/remittance';
import PaymentInfo from "./PaymentInfoCard";

const AgencyRemittanceCard = (props: any) => {
  const { id,type } = useParams<{ id: string,type:string }>()
  const { translations } = useLanguage();
  const [remittanceDetail , setRemittanceDetail] = useState<any>({});
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState<string>(translations.Remittance?.["SAVE_DETAIL_CONFIRMATION"]);
  const [confirmationFrom, setConfirmationFrom] = useState<string>("InsurerPartnerRemittance")
  const [LeadAssignTo, setLeadAssignTo] = useState<string>("");
  const [remittanceType, setRemittanceType] = useState<string>("");
  const [leadRemark, setLeadRemark] = useState<string>("");

  useEffect(() => {
    if (Array.isArray(props.remittanceDetails) && props.remittanceDetails.length > 0) {
      const agencyRemittance = props.remittanceDetails.find((b: any) => b.remittance_type_name === REMITTANCE_TYPE['agency']);
      setRemittanceType(REMITTANCE_TYPE['agency']);
      if(agencyRemittance){
        setRemittanceDetail(agencyRemittance);
        props.setSelectedFilters((prev:any) => ({
          ...prev,
          amount_remitted_to_agency: agencyRemittance.amount_remitted_to_agency,
          amount_received_from_agency: agencyRemittance.amount_received_from_agency,
          referral_fee_date : agencyRemittance.referral_fee_payout_date ? moment(agencyRemittance.referral_fee_payout_date).format('YYYY-MM-DD') : null,
        }));
      }
    }
    // eslint-disable-next-line
    },[props.remittanceDetails])

   /**
   * Validate Partner Form
   * @returns 
   */
  const validateForm = () => {
    const newErrors: any = {};
    // Example validations
    if (!props.selectedFilters?.amount_remitted_to_agency) {
      newErrors.amount_remitted_to_agency = "Amount Remitted to agency is required";
    }
    if (!props.selectedFilters?.amount_received_from_agency) {
      newErrors.amount_received_from_agency = "Amount Received from agency is required";
    }
    // if (!props.selectedFilters?.referral_fee_date) {
    //   newErrors.referral_fee_date = "Referral fee date is required";
    // }
    props.setErrors(newErrors);
    // return true only if no errors
    return Object.keys(newErrors).length === 0;
  };

  const cancelFormChange = async () => {
    props.setFormAgencyChangeDetect(false);
    props.setCallReloadApi(props.callReloadApi+1);
  }

  const askTosaveDetail = () => {
    try{
      if(props.isMakerLoggedIn || (props.isAdminLoggedIn && ADMIN_MAKER_STATUS.includes(remittanceDetail?.remittance_status))){
        setConfirmationMessage(translations.Remittance?.["SEND_TO_OPS_CONFIRMATION"]);
        setConfirmationFrom("SendToMaker");
        setLeadAssignTo(LEAD_ASSIGN_TO['REM_OPS']);
        setShowConfirmation(true);
      }else if (props.isCheckerLoggedIn || (props.isAdminLoggedIn && ADMIN_CHECKER_STATUS.includes(remittanceDetail?.remittance_status))) {
        setConfirmationMessage(translations.Remittance?.["SEND_TO_MAKER_CONFIRMATION"]);
        setConfirmationFrom("SendToMaker");
        setLeadAssignTo(LEAD_ASSIGN_TO['REM_FINANCE_MAKER']);
        setShowConfirmation(true);
      }else{
        if(props.isOpsLoggedIn || (props.isAdminLoggedIn && ADMIN_OPS_STATUS.includes(remittanceDetail?.remittance_status))){
          if(props.formAgencyChangeDetect){
            const isFormValid = validateForm();
            if(isFormValid){
              props.setErrors({});
              setConfirmationMessage(translations.Remittance?.["SAVE_DETAIL_CONFIRMATION"]);
              setConfirmationFrom("SaveDetail");
              setLeadAssignTo("");
              setShowConfirmation(true);
            }
          }else{
            setConfirmationMessage(translations.Remittance?.["SEND_TO_MAKER_CONFIRMATION"]);
            setConfirmationFrom("SendToMaker");
            setLeadAssignTo(LEAD_ASSIGN_TO['REM_FINANCE_MAKER']);
            setShowConfirmation(true);
          }
        }
      }
    }catch (error) {
        console.error("Error while updating remittance detail:", error);
    }
  }

  const saveDetail = async () => {
      try{
         setLoading(true);
        const payload = {
          lead_id : id,
          referral_amount : String(props.selectedFilters?.amount_remitted_to_agency),
          recieved_amount : String(props.selectedFilters?.amount_received_from_agency),
          referral_fee_date : props.selectedFilters?.referral_fee_date,
          type : REMITTANCE_TYPE['agency'],
          ...((props.isCheckerLoggedIn || ADMIN_CHECKER_STATUS.includes(remittanceDetail?.remittance_status)) && { mark_payment_complete: true }),
          ...((props.isCheckerLoggedIn || ADMIN_CHECKER_STATUS.includes(remittanceDetail?.remittance_status)) && { remarks: leadRemark })
        };
        const response:any = await saveRemittanceDetails(payload);
        if (response?.status === 200) {
          props.setCallReloadApi(props.callReloadApi+1);
          props.setFormAgencyChangeDetect(false);
          setShowConfirmation(false);
        }
      }catch (error) {
        console.error("Error while save Remittance Partner Detail:", error);
      }finally {
        setLoading(false);
      }
    }

    const reloadDetail = async () => {
      props.setCallReloadApi(props.callReloadApi+1);
    }

  const markPaymentComplete = () => {
    setConfirmationMessage(translations.Remittance?.["COMPLETE_PAYMENT_CONFIRMATION"]);
    setConfirmationFrom("InsurerPartnerRemittance");
    setLeadAssignTo("");
    setShowConfirmation(true);
  }

  const validTypes = Object.values(REMITTANCE_TYPE);
  const currentType = validTypes.includes(type) ? type : null;
  const isAgencyDisabled = currentType !== REMITTANCE_TYPE.agency;
  let vat = props.revenue.agency_vat;
  const wht = props.revenue?.agency_wht;
  const actual_referral_fee_payout = props.revenue?.referral_fee_payout_wht_inclusive - wht + vat;
  return (
    <>
      <FullPageLoader show={loading} />
      {
        showConfirmation && 
        <ConfirmPopup
            confirmNo={() => setShowConfirmation(false)}
            confirmYes={saveDetail}
            message={confirmationMessage}
            isConfirmNotVisible={true} 
            from={confirmationFrom}
            LeadAssignTo={LeadAssignTo}
            remittanceType={remittanceType}
            reloadDetail={reloadDetail}
            setLeadRemark={setLeadRemark}>
        </ConfirmPopup>
      }
      {/* Agency Remittance */}
      <div className={`remittance-card`}>
        {
          isAgencyDisabled &&
          <div className="card-dissable"></div>
        }
        <div className="remittance-header">
          <h2>{translations.Remittance?.["AGENCY_REMITTANCE"] || translations.commonMsg?.loading}</h2>
        </div>

        <div className="remittance-table dealer-agency">
          <div className="remittance-row">
            <span className="remittance-row-heading">{translations.Remittance?.["ACTUAL_REMITTANCE_REFERRAL_FEE_PAYOUT"] || translations.commonMsg?.loading}</span>
            <span className="value">{`${HELPER.addCurrencyFormatting(Number(props.revenue?.referral_fee_payout_wht_inclusive || 0).toFixed(2))}`}</span>
          </div>
          <div className="remittance-row">
            <span className="remittance-row-heading">{translations.Remittance?.["BANK_NAME"] || translations.commonMsg?.loading}</span>
            <span className="value bold-value">{remittanceDetail?.bank_name}</span>
          </div>
          <div className="remittance-row">
            <span className="remittance-row-heading">{translations.Remittance?.["Actual_Referral_Fee_Payout"] || translations.commonMsg?.loading}</span>
            <span>{`${HELPER.addCurrencyFormatting(Number(actual_referral_fee_payout || 0).toFixed(2))}`}</span>
          </div>
          <div className="remittance-row">
            <span className="remittance-row-heading">{translations.Remittance?.["BANK_ACCOUNT_NO"] || translations.commonMsg?.loading}</span>
            <span className="value bold-value">{remittanceDetail?.account_number}</span>
          </div>
          <div className="remittance-row">
            <span className="remittance-row-heading">{translations.Remittance?.["AMOUNT_REMITTED_TO_AGENCY"] || translations.commonMsg?.loading}</span>
            <input
              type="text"
              value={
                (
                  // OPS can edit
                  (props.isOpsLoggedIn &&
                    props.roleStatus?.includes(remittanceDetail?.remittance_status) &&
                    +remittanceDetail?.ops_id === +props.currentLoggedInUser)
                  ||
                  // ADMIN can edit when status is 1 or 2 (no roleStatus check)
                  (props.isAdminLoggedIn &&
                    ADMIN_OPS_STATUS.includes(remittanceDetail?.remittance_status))
                )
                  ? props.selectedFilters?.amount_remitted_to_agency || ""
                  : HELPER.addCurrencyFormatting(props.selectedFilters?.amount_remitted_to_agency || 0)
              }
              className={
                !props.isOpsLoggedIn && !props.isAdminLoggedIn
                  ? "inputui input-bg-colur"
                  : (
                      // OPS condition
                      (props.isOpsLoggedIn &&
                        props.roleStatus?.includes(remittanceDetail?.remittance_status) &&
                        +remittanceDetail?.ops_id === +props.currentLoggedInUser)
                      ||
                      // ADMIN condition (no roleStatus check)
                      (props.isAdminLoggedIn &&
                        ADMIN_OPS_STATUS.includes(remittanceDetail?.remittance_status))
                    )
                  ? "inputui"
                  : "inputui input-bg-colur"
              }
              onChange={(e) => props.handleChange(e.target.value, "amount_remitted_to_agency")}
              readOnly={
                !(
                  (props.isOpsLoggedIn &&
                    props.roleStatus?.includes(remittanceDetail?.remittance_status) &&
                    +remittanceDetail?.ops_id === +props.currentLoggedInUser)
                  ||
                  (props.isAdminLoggedIn &&
                    ADMIN_OPS_STATUS.includes(remittanceDetail?.remittance_status))
                )
              }
            />

            {props.errors?.amount_remitted_to_agency && (
              <small className="error">{props.errors?.amount_remitted_to_agency}</small>
            )}
          </div>
          <div className="remittance-row">
            <span className="remittance-row-heading">{translations.Remittance?.["ACCOUNT_NAME_BENEFICIARY"] || translations.commonMsg?.loading}</span>
            <span className="value bold-value">{remittanceDetail?.beneficiary_name}</span>
          </div>
          <div className="remittance-row">
            <span className="remittance-row-heading">{translations.Remittance?.["AMOUNT_RECEIVED_FROM_AGENCY"] || translations.commonMsg?.loading}</span>
            <input
              type="text"
              value={
                (
                  // OPS can edit
                  (props.isOpsLoggedIn &&
                    props.roleStatus?.includes(remittanceDetail?.remittance_status) &&
                    +remittanceDetail?.ops_id === +props.currentLoggedInUser)
                  ||
                  // ADMIN can edit (status 1 or 2, no roleStatus check)
                  (props.isAdminLoggedIn &&
                    ADMIN_OPS_STATUS.includes(remittanceDetail?.remittance_status))
                )
                  ? props.selectedFilters?.amount_received_from_agency || ""
                  : HELPER.addCurrencyFormatting(props.selectedFilters?.amount_received_from_agency || 0)
              }
              className={
                !props.isOpsLoggedIn && !props.isAdminLoggedIn
                  ? "inputui input-bg-colur"
                  : (
                      // OPS condition
                      (props.isOpsLoggedIn &&
                        props.roleStatus?.includes(remittanceDetail?.remittance_status) &&
                        +remittanceDetail?.ops_id === +props.currentLoggedInUser)
                      ||
                      // ADMIN condition (no roleStatus check)
                      (props.isAdminLoggedIn &&
                        ADMIN_OPS_STATUS.includes(remittanceDetail?.remittance_status))
                    )
                  ? "inputui"
                  : "inputui input-bg-colur"
              }
              onChange={(e) => props.handleChange(e.target.value, "amount_received_from_agency")}
              readOnly={
                !(
                  (props.isOpsLoggedIn &&
                    props.roleStatus?.includes(remittanceDetail?.remittance_status) &&
                    +remittanceDetail?.ops_id === +props.currentLoggedInUser)
                  ||
                  (props.isAdminLoggedIn &&
                    ADMIN_OPS_STATUS.includes(remittanceDetail?.remittance_status))
                )
              }
            />

            {props.errors?.amount_received_from_agency && (
              <small className="error">{props.errors?.amount_received_from_agency}</small>
            )}
          </div>
          <div className="remittance-row">
            <span className="remittance-row-heading">{translations.Remittance?.["BRANCH_NAME"] || translations.commonMsg?.loading}</span>
            <span className="value bold-value">{remittanceDetail?.branch_name}</span>
          </div>
          <div className="remittance-row">
            <span className="remittance-row-heading">{translations.Remittance?.["FINAL_REMITTANCE_TO_AGENCY"] || translations.commonMsg?.loading}</span>
            <span className="highlight-blue">
              {HELPER.addCurrencyFormatting(
                (
                  Number(remittanceDetail?.actual_remittance || 0) -
                  (
                    Number(remittanceDetail?.amount_remitted_to_agency || 0) +
                    Number(remittanceDetail?.amount_received_from_agency || 0)
                  )
                ).toFixed(2)
              )}
            </span>
          </div>
          <div className="remittance-row">
            <span className="remittance-row-heading">{translations.Remittance?.["TIN_ID"] || translations.commonMsg?.loading}</span>
            <span className="value bold-value">{remittanceDetail?.tin_id}</span>
          </div>
          <div className="remittance-row">
            <span className="remittance-row-heading">{translations.Remittance?.["REFERRAL_FEE_PAYOUT_DATE"] || translations.commonMsg?.loading}</span>
            {/* <input type="text" value="22 Jul, 2026" className="inputui" readOnly /> */}
            {
             (( props.isOpsLoggedIn && props.roleStatus?.includes(remittanceDetail?.remittance_status) && +remittanceDetail?.ops_id === +props.currentLoggedInUser) || (props.isAdminLoggedIn && ADMIN_OPS_STATUS.includes(remittanceDetail?.remittance_status))) ?
              <RemittanceDate name="referral_fee_date" maxDate={new Date()} selectedFilters={props.selectedFilters}  placeholder={translations.Remittance?.["REFERRAL_FEE_PAYOUT_DATE"] || translations.commonMsg?.loading} className="datepickerInput" handleChange={props.handleChange}/>
              :
              <input type="text" className={!props.isOpsLoggedIn ? "inputui input-bg-colur" : props.roleStatus?.includes(remittanceDetail?.remittance_status) && +remittanceDetail?.ops_id === +props.currentLoggedInUser ? "inputui" : "inputui input-bg-colur"} value={props.selectedFilters.referral_fee_date ? moment(props.selectedFilters.referral_fee_date).format("DD MMM, YYYY") : ''} readOnly />
            }
             {props.errors?.referral_fee_date && (
              <small className="error">{props.errors?.referral_fee_date}</small>
            )}
          </div>
          <div className="remittance-row">
            <span className="remittance-row-heading">{translations.Remittance?.["PAYMENT_FROM"] || translations.commonMsg?.loading}</span>
            <span className="bold-value">{remittanceDetail?.payment_from || ''}</span>
          </div>
          <div className="remittance-row">
            <span className="remittance-row-heading">{translations.Remittance?.["VAT"] || translations.commonMsg?.loading}</span>
            <span>{`${HELPER.addCurrencyFormatting(Number(vat || 0).toFixed(2))}`}</span>
          </div>
          <div className="remittance-row"></div>
          <div className="remittance-row">
            <span className="remittance-row-heading">{translations.Remittance?.["WITHHOLDING_TAX"] || translations.commonMsg?.loading}</span>
            <span>{`${HELPER.addCurrencyFormatting(Number(wht || 0).toFixed(2))}`}</span>
          </div>
        </div>
        {
          ((remittanceDetail?.payment && props.isCheckerLoggedIn && +remittanceDetail?.checker_id === +props.currentLoggedInUser) || (remittanceDetail?.payment && props.isAdminLoggedIn && ADMIN_CHECKER_COMPLETE_STATUS.includes(remittanceDetail?.remittance_status))) &&
          <PaymentInfo remittanceDetail={remittanceDetail}></PaymentInfo>
        }
        {
          currentType === REMITTANCE_TYPE.agency &&
          <>
            {
              props.isOpsLoggedIn && props.roleStatus?.includes(remittanceDetail?.remittance_status) && +remittanceDetail?.ops_id === +props.currentLoggedInUser &&
              <>
                <button className={`save-btn ${props.formAgencyChangeDetect ? "backtoopsbutoon" : ""}`} onClick={askTosaveDetail}>{translations.Remittance?.[!props.formAgencyChangeDetect ? "SEND_TO_MAKER" : "SAVE_DETAILS"] || translations.commonMsg?.loading}</button>
                {props.formAgencyChangeDetect && (
                  <button className="cancle-btn" onClick={cancelFormChange}>{translations.Remittance?.CANCEL || "Cancel"}</button>
                )}
              </>
            }
            {
              props.isMakerLoggedIn && props.roleStatus?.includes(remittanceDetail?.remittance_status) && +remittanceDetail?.maker_id === +props.currentLoggedInUser &&
                <div>
                  <button className="save-btn backtoopsbutoon" onClick={askTosaveDetail}>{translations.Remittance?.["BACK_TO_OPS"] || translations.commonMsg?.loading}</button>
                  <button className="save-btn" onClick={() => props.makePayment(remittanceType)}>{translations.Remittance?.["MAKE_PAYMENT"] || translations.commonMsg?.loading}</button>
                </div>
            }
            {
              props.isCheckerLoggedIn && props.roleStatus?.includes(remittanceDetail?.remittance_status) && +remittanceDetail?.checker_id === +props.currentLoggedInUser &&
              <div>
                <button className="save-btn backtoopsbutoon" onClick={askTosaveDetail}>{translations.Remittance?.["BACK_TO_MAKER"] || translations.commonMsg?.loading}</button>
                <button className="save-btn" onClick={markPaymentComplete}>{translations.Remittance?.["MARK_AS_COMPLETE"] || translations.commonMsg?.loading}</button>
              </div>
            }
            {/* ============================== */}
            {/* ADMIN-ONLY BUTTON CONDITIONS */}
            {/* ============================== */}
            {/* Admin sees OPS button when status is 1 or 2 */}
            {
              props.isAdminLoggedIn && ADMIN_OPS_STATUS.includes(remittanceDetail?.remittance_status) && (
                <>
                  <button className={`save-btn ${props.formAgencyChangeDetect ? "backtoopsbutoon" : ""}`} onClick={askTosaveDetail}>
                    {translations.Remittance?.[!props.formAgencyChangeDetect ? "SEND_TO_MAKER" : "SAVE_DETAILS"] || translations.commonMsg?.loading}
                  </button>
                  {props.formAgencyChangeDetect && (
                    <button className="cancle-btn" onClick={cancelFormChange}>{translations.Remittance?.CANCEL || "Cancel"}</button>
                  )}
                </>
              )
            }
            {/* Admin sees MAKER buttons when status is 3 or 4 */}
            {
              props.isAdminLoggedIn && ADMIN_MAKER_STATUS.includes(remittanceDetail?.remittance_status) && (
                <div>
                  <button className="save-btn backtoopsbutoon" onClick={askTosaveDetail}>
                    {translations.Remittance?.["BACK_TO_OPS"] || translations.commonMsg?.loading}
                  </button>
                  <button className="save-btn" onClick={() => props.makePayment(remittanceType)}>
                    {translations.Remittance?.["MAKE_PAYMENT"] || translations.commonMsg?.loading}
                  </button>
                </div>
              )
            }
            {/* Admin sees CHECKER buttons when status is 5 */}
            {
              props.isAdminLoggedIn && ADMIN_CHECKER_STATUS.includes(remittanceDetail?.remittance_status) && (
                <div>
                  <button className="save-btn backtoopsbutoon" onClick={askTosaveDetail}>
                    {translations.Remittance?.["BACK_TO_MAKER"] || translations.commonMsg?.loading}
                  </button>
                  <button className="save-btn" onClick={markPaymentComplete}>
                    {translations.Remittance?.["MARK_AS_COMPLETE"] || translations.commonMsg?.loading}
                  </button>
                </div>
              )
            }
          </>
        }
      </div>
    </>
  );
};

export default AgencyRemittanceCard;
